const Web3 = require('web3');
const abi = require('./abi.js');
let bigInt = require("big-integer");

const contract_address = "0xd182BA43054d6EFd9e45D095e1b123D3c5f54811"

class Web3Adapter {
    constructor(cb) {
        this.cb = cb
        this.web3 = false;
        this.contract = false;
        this.abi = abi;
    }
    async init(provider) {
        if (!provider) {
            return;
        }
        try {
            this.web3 = new Web3(provider);
            this.contract = new this.web3.eth.Contract(this.abi, contract_address);
            this.cb.call(this, "connected", "connected")
        }
        catch (ex) {
            console.log(ex)
            return;
        }
    }

    async freeClaim() {
        try {
            let gasPrice = await this.web3.eth.getGasPrice();
            let account = await this.web3.eth.getAccounts();
            account = account[0]
            console.log(account)
            let gasEst = await this.contract.methods["freeClaim"]().estimateGas({ from: account, gasPrice: gasPrice })
            await this.contract.methods["freeClaim"]().send({ from: account, gas: gasEst, gasPrice: gasPrice })
            this.cb.call(this, "success");
        }
        catch (ex) {
            this.cb.call(this, "error", "")
        }
    }

    async purchase(amount) {
        try {
            if (amount > 20) {
                throw "Attempting to buy too many"
            }
            console.log(amount)
            let price = bigInt("200000000000000000").multiply(amount)
            let gasPrice = await this.web3.eth.getGasPrice();
            let account = await this.web3.eth.getAccounts();
            account = account[0]
            let gasEst = await this.contract.methods["mint"](amount).estimateGas({ from: account, value: price.toString(), gasPrice: gasPrice })
            await this.contract.methods["mint"](amount).send({ from: account, value: price.toString(), gas: gasEst, gasPrice: gasPrice })
            let supply = await this.remaining();
            this.cb.call(this, "purchased", supply)
        }
        catch (ex) {
            console.log(ex)
            this.cb.call(this, "error", "")
        }
    }
    async remaining() {
        try {
            let supply = await this.contract.methods["purchased"]().call({ gas: "500000000" })
            let remaining = 1111 - supply;
            return remaining;
        }
        catch (ex) {
            console.log(ex)
            this.cb.call(this, "error", "")
            return '-'
        }
    }

    async checkClaim(tokenId) {
        try {
            let account = await this.web3.eth.getAccounts();
            account = account[0]
            let canClaim = await this.contract.methods["canTokenClaim"](tokenId.toString()).call({ from: account, gas: "50000000" })
            console.log(canClaim)
            this.cb.call(this, "claimCheck", canClaim)
        }
        catch (ex) {
            console.log(ex)
            this.cb.call(this, "claimCheck", "?")
        }
    }
}

export default Web3Adapter;